import TimeLineDetails from "components/Timeline/TimeLineDetails";
import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppRoutes } from "utils/routes";
import { useModal } from "contexts/modal";
import Vidoes from "./pages/Vidoes"
import "../src/components/AppLayout/AppLayout.scss";
const AppLayout = lazy(() => import("./components/AppLayout"));
const Landing = lazy(() => import("./pages/Landing"));
const KeyEventDetails = lazy(() => import("./pages/KeyEventDetail"));
const KeyEvents = lazy(() => import("./pages/KeyEvents"));
const Menu = lazy(() => import("./pages/Menu"));

const  Router = () => {
  const { isOpen } = useModal();
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path={AppRoutes.home} element={<AppLayout />}>
            <Route path={AppRoutes.home} element={<Landing />} />
            <Route path={AppRoutes.keyEvents} element={<KeyEvents />} />
            <Route
              path={AppRoutes.keyEventDetails}
              element={<KeyEventDetails />}
            />
            <Route path={AppRoutes.menu} element={<Menu />} />
            
          </Route>
          <Route path={AppRoutes.vidoesPage}  element={<Vidoes />} />
        </Routes>
        <div className="main-screen">
          {!isOpen && <TimeLineDetails />}
        </div>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
